import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();
  const pathSegments = location?.pathname?.split('/')?.filter(Boolean);

  const breadcrumbMap = {
    'compliance-overview': 'Overview',
    'violation-analytics': 'Analytics',
    'employee-compliance': 'Employees'
  };

  if (pathSegments?.length === 0) return null;

  const breadcrumbs = pathSegments?.map((segment, index) => {
    const path = `/${pathSegments?.slice(0, index + 1)?.join('/')}`;
    const label = breadcrumbMap?.[segment] || segment?.split('-')?.map(word => 
      word?.charAt(0)?.toUpperCase() + word?.slice(1)
    )?.join(' ');
    
    return {
      label,
      path,
      isLast: index === pathSegments?.length - 1
    };
  });

  return (
    <nav aria-label="Breadcrumb" className="py-4">
      <ol className="flex items-center gap-2 text-sm font-caption">
        <li>
          <Link
            to="/"
            className="flex items-center gap-1 text-muted-foreground hover:text-foreground transition-smooth"
          >
            <Icon name="Home" size={16} />
            <span>Home</span>
          </Link>
        </li>
        
        {breadcrumbs?.map((crumb, index) => (
          <li key={crumb?.path} className="flex items-center gap-2">
            <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
            {crumb?.isLast ? (
              <span className="text-foreground font-medium" aria-current="page">
                {crumb?.label}
              </span>
            ) : (
              <Link
                to={crumb?.path}
                className="text-muted-foreground hover:text-foreground transition-smooth"
              >
                {crumb?.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;